import styled from "styled-components";

export const GameBodyBox = styled.div<{backgroundImageUrl: string}>`
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-image: url("${props => props.backgroundImageUrl}");
  background-repeat: no-repeat;
  background-clip: border-box;
  background-color: ${props => props.theme.colors.background};
  background-attachment: fixed;
  background-position: center center;
  background-size: 100% 100%;
  @media ${props => props.theme.mediaQuery.sAndBelow} {
    padding: 0;
  }

  @media ${props => props.theme.mediaQuery.lAndBelow} {
    background-image: none;
  }

`
